import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return toast.error("Las contraseñas no coinciden");
    if (next.length < 6) return toast.error("Mínimo 6 caracteres");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      const u = await refresh();
      toast.success("Contraseña actualizada");
      navigate(u.role === "cajero" ? "/admin/pos" : "/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="font-display text-5xl tracking-[0.15em] text-espresso">MO</div>
          <span className="font-serif italic text-rose text-lg">by Vir</span>
          <p className="text-[11px] uppercase tracking-[0.25em] text-taupe mt-4">Cambia tu contraseña</p>
          {user?.must_change_password && <p className="text-xs text-taupe mt-2">Por seguridad, debes cambiar tu contraseña temporal antes de continuar.</p>}
        </div>
        <form onSubmit={submit} className="space-y-6">
          <Field label="Contraseña actual" testid="cp-current" value={current} onChange={setCurrent} />
          <Field label="Nueva contraseña" testid="cp-new" value={next} onChange={setNext} />
          <Field label="Confirmar nueva contraseña" testid="cp-confirm" value={confirm} onChange={setConfirm} />
          <button data-testid="cp-submit" type="submit" disabled={loading}
            className="w-full bg-espresso text-cream rounded-full py-4 text-xs uppercase tracking-[0.2em] hover:bg-rose transition-colors disabled:opacity-60">
            {loading ? "Guardando..." : "Guardar contraseña"}
          </button>
        </form>
      </div>
    </div>
  );
}

const Field = ({ label, testid, value, onChange }) => (
  <div>
    <label className="text-[11px] uppercase tracking-[0.2em] text-taupe">{label}</label>
    <input data-testid={testid} type="password" value={value} onChange={(e) => onChange(e.target.value)}
      className="w-full mt-2 bg-transparent border-b border-line py-3 focus:outline-none focus:border-rose transition-colors font-light" />
  </div>
);
